module.exports = __webpack_public_path__ + "static/media/vtex24.4ad86bd1.png";